// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import FormValidation, {getDefaultState as getFormValidationDefaultState} from './form-validation';
import Product, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import Registration, {getDefaultState as getRegistrationDefaultState} from '@deere/cps-it.warranty-model-factory/lib/registration';
import RegistrationDomainValues, {getDefaultState as getRegistrationDomainValuesDefaultState} from './registration-domain-values';
import RegistrationModals, {getDefaultState as getRegistrationModalDefaultState} from './registration-modals';
import User, {getDefaultState as getUserDefaultState} from '@deere/cps-it.warranty-model-factory/lib/user';
import t from 'tcomb';

const ProductRegistration = t.struct({
    busyCounter: BusyCounter,
    formValidation: FormValidation,
    isAmountOfUseModalOpen: t.Boolean,
    previousDeliveryDate: t.maybe(t.Number),
    product: t.maybe(Product),
    registration: t.maybe(Registration),
    registrationDomainValues: RegistrationDomainValues,
    registrationModals: RegistrationModals,
    user: User
}, 'ProductRegistration');

export const getDefaultState = () =>
    new ProductRegistration({
        busyCounter: getBusyCounterDefaultState(),
        formValidation: getFormValidationDefaultState(),
        isAmountOfUseModalOpen: false,
        previousDeliveryDate: 0,
        product: getProductDefaultState(),
        registration: getRegistrationDefaultState(),
        registrationDomainValues: getRegistrationDomainValuesDefaultState(),
        registrationModals: getRegistrationModalDefaultState(),
        user: getUserDefaultState()
    });

export default ProductRegistration;



// WEBPACK FOOTER //
// ./src/product/product-registration/state/index.js